import React from 'react';
import List from '@mui/material/List';
import { SxProps, Theme } from '@mui/material';

type StyledListProps = {
  children?: React.ReactNode;
  collapse?: boolean;
  level?: number;
  sx?: SxProps<Theme>;
};

function StyledList({ children, collapse = false, level, sx }: StyledListProps) {
  const railColor = 'rgba(0, 0, 0, 0.2)';

  return (
    <List
      sx={{
        paddingLeft: '0',
        paddingTop: '0',
        paddingBottom: '0',
        marginBottom: '0',
        listStyle: 'none',
        color: 'inherit',
        '&:before,&:after': {
          display: 'table',
          content: '" "',
        },
        '&:after': {
          clear: 'both',
        },
        // collapse styles: thin vertical rail for hierarchy
        ...(collapse && {
          display: 'block',
          marginTop: '4px',
          marginBottom: '4px',
          marginLeft: '28px',
          paddingLeft: '12px',
          // thin rail on the left to show hierarchy
          borderLeft: `1px solid ${railColor}`,
          backgroundColor: 'transparent',
        }),
        ...sx,
      }}
    >
      {children}
    </List>
  );
}

export default StyledList;
